import React from 'react';
import TextModal from '../../../components/Common/TextModal';
import { BookModel } from '../../../interfaces/book.interface';
import { PageDetailsModel } from '../../../interfaces/common.interface';

interface PageCardProps {
  pageDetails: PageDetailsModel | null;
  index: number;
  totalPages: number;
  bookData: BookModel | null;
  isModalOpen: boolean;
  handleCloseModal: () => void;
  selectedPageDetails: PageDetailsModel | null;
}

const BookPageCard: React.FC<PageCardProps> = ({
                                                 pageDetails,
                                                 index,
                                                 totalPages,
                                                 bookData,
                                                 isModalOpen,
                                                 handleCloseModal,
                                                 selectedPageDetails
                                               }: PageCardProps) => {
  return (
    <>
      <div
        className="h-[18rem] w-[18rem] md:w-[800px] md:h-[800px] mx-auto pt-8 flex flex-col justify-between rounded-lg"
        style={{
          backgroundImage: `url("/paper.jpg")`,
          backgroundSize: 'cover'
        }}
      >
        <h3
          className={`h-[18rem] w-[18rem] md:h-[800px] md:w-[800px] flex p-[2rem] text-justify justify-center font-bold font-poppins overflow-auto ${
            bookData?.childAge === 'AGE_0_2'
              ? 'text-5xl md:px-[8rem] md:py-[18rem]'
              : bookData?.childAge === 'AGE_3_7'
                ? 'text-3xl md:px-[6rem] md:py-[14rem]'
                : bookData?.childAge === 'AGE_8_12'
                  ? 'text-2xl md:px-[4rem] md:py-[10rem]'
                  : 'text-xl'
          }`}
        >
          {pageDetails?.text}
        </h3>
        <TextModal
          openDialog={isModalOpen}
          handelClose={handleCloseModal}
          fullText={pageDetails?.text!}
          pageDetails={selectedPageDetails!}
        />
        <div className="page-number mb-2 w-full flex justify-center">
          <div className="bg-storyblue w-12 h-6 flex justify-center rounded-full text-white text-base"
               style={{ fontFamily: 'system-ui' }}>
            {index * 2 + 1}/{totalPages - 1}
          </div>
        </div>
      </div>
      <div
        className="w-[18rem] h-[18rem] md:w-[800px] md:h-[800px] rounded-lg mx-auto flex flex-col justify-end"
        style={{
          backgroundImage: `url('${pageDetails?.imageURLwebp || pageDetails?.imageURL || '/pattern.png'}')`,
          backgroundSize: 'contain'
        }}
      >
        <div className="page-number mb-2 w-full flex justify-center">
          <div className="bg-storyblue w-12 flex justify-center rounded-full text-white">
            {index * 2 + 2}/{totalPages - 1}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookPageCard;
